import { ProjectLimitsSchema, SellerSchema, type BillingSettings, type PublicProvider, type ServerProviderSettings, type UsageBody } from "@tasduvar/shared";
import { api } from "../api/client";
import { normalizeSettings } from "./localStorageProviderStore";
import type { ProviderSettings, ProviderStore, UsageEntry } from "./types";

/**
 * Sunucudaki sağlayıcı ayarları. Yönetici tam ayarı (IBAN dâhil) okur/yazar; diğer herkes herkese açık kesiti okur.
 * Parola ve kullanım günlüğü sunucuda (v1.0 alanları boş kalır).
 */
export class ApiProviderStore implements ProviderStore {
  constructor(private readonly ctx: { isAdmin(): boolean; isAuthed(): boolean }) {}
  async get(): Promise<ProviderSettings> {
    const raw = this.ctx.isAdmin()
      ? await api<ServerProviderSettings>("GET", "/admin/settings")
      : await api<PublicProvider>("GET", "/provider/public");
    const s = normalizeSettings({ ...raw, passwordHash: "", usageLog: [] });
    return { ...s, billing: (raw as Partial<ServerProviderSettings>).billing, seller: raw.seller, limits: (raw as Partial<ServerProviderSettings>).limits };
  }
  async set(s: ProviderSettings): Promise<void> {
    if (!this.ctx.isAdmin()) throw new Error("Ayarları yalnız yönetici değiştirebilir");
    const body: ServerProviderSettings = { version: 1, imagePdf: s.imagePdf, branding: s.branding, defaults: s.defaults as ServerProviderSettings["defaults"], features: s.features, billing: s.billing ?? { iban: "", accountHolder: "", transferNote: "" }, seller: s.seller ?? SellerSchema.parse({}), limits: s.limits ?? ProjectLimitsSchema.parse({}) };
    await api("PUT", "/admin/settings", body);
  }
  async appendLog(e: UsageEntry): Promise<void> {
    if (!this.ctx.isAuthed()) return; // misafir kullanımı sunucuya yazılmaz
    const body: UsageBody = { projectName: e.projectName, wallCount: e.wallCount, format: e.format, projectId: e.projectId };
    await api("POST", "/usage", body);
  }
}

export type { BillingSettings };
